import React from 'react';

//REQUIRES
/* 
 * @param images Array of Image URLs
 * @param display_linit Integer of how many images to squeeze in the row
 * 
*/
class ImageScroller extends React.Component {

	constructor(props) {
		super(props);

		this.scrollRight = this.scrollRight.bind(this);
		this.scrollLeft = this.scrollLeft.bind(this);

		this.state = {
			offset : 0
		};
	}

	scrollLeft(e) {
		var curOffset = this.state.offset;
		var newOffset = curOffset - 1;
		if(newOffset < 0) {
			newOffset = this.props.images.length - 1;
		}

		this.setState({offset : newOffset});
	}

	scrollRight(e) {
		var curOffset = this.state.offset;
		var newOffset = curOffset + 1;
		if(newOffset >= this.props.images.length) {
			newOffset = 0;
		}

		this.setState({offset : newOffset});
	}

	render() {
		var images = (this.props.images && this.props.images.length) ? this.props.images : false;

		if(!images)  {
			return (
				<div className="No-Images"></div>
			);
		}

		var imageArrayContent = [];
		var imagesCopy = []; //strip out undefined or no image 
		for(var j = 0; j != images.length; ++j) {
			if(typeof images[j] === 'undefined' || images[j].length === 0 || imagesCopy.includes(images[j]) ) {
				continue;
			}
			imagesCopy.push(images[j]);
		}

		images = imagesCopy;

		for(var i = 0; i !== images.length; ++i) {
			if(i >= this.props.display_limit) {
				break;
			}

			var imageIndex = (images.length <= i + this.state.offset) ? i + this.state.offset - images.length : (i + this.state.offset < 0) ? images.length + i + this.state.offset : i + this.state.offset;
			
			if(typeof images[imageIndex] === 'undefined' || images[imageIndex].length === 0) continue;

			var imageContent = (
				<div key={'imagescroller-box-' + images[imageIndex]} className='ImageBox'>
					<img key={'imagescroller-' + images[imageIndex]} src={images[imageIndex]} alt={'scroller ico ' + i}/>
				</div>
				);
			imageArrayContent.push(imageContent);
		}

		var scrollerContent = (images.length > this.props.display_limit) ? 
			[(<div className='ScrollLeftButton' onClick={this.scrollLeft}><img src={process.env.PUBLIC_URL + "images/white-arrow@2x.png"} alt='scroll icon scroller left' /></div>),
				(<div className='ImageDisplay'>
					{imageArrayContent}
				</div>),
				(<div className='ScrollRightButton' onClick={this.scrollRight}><img src={process.env.PUBLIC_URL + "images/white-arrow@2x.png"} alt='scroll icon scroller right' /></div>)] : (<div className='ImageDisplay'>
					{imageArrayContent}
				</div>);


		return (
			<div className='ImageScroller'>
				{scrollerContent}
			</div>
		);
	}
}


export default ImageScroller;